/* eslint-disable consistent-return */
import { Typography } from '@mui/material';
import { isEmptyObject } from 'helpers/objectFunctions';
import { devConsolelog } from 'helpers/utilityFunctions';
import {
    AREA_FIELD_KEY,
    HOTELS_AND_SIGHTSEEING,
    HOTEL_FIELD_KEY,
    NUMBER_OF_NIGHTS_FIELD_KEY,
    RESORT,
    SIGHTSEEING_FIELD,
    monthNames
} from './constants';
import { green } from '@mui/material/colors';
import { cloneDeep } from 'lodash';
import { addDays, format, parse } from 'date-fns';

export const getDateAndMonth = (timestamp = '', appendYear = false, shareFormat = false) => {
    if (!timestamp) return;
    // let d = new Date(timestamp);
    // let month = monthNames[d.getMonth()];
    // let date = d.getDate();
    // return `${date} ${month}`;

    let time = timestamp.split('T')[0];
    time = time.split('-');
    const day = time.length > 2 ? time[2] : null;
    let month = time.length > 2 ? time[1] : null;
    const year = time.length > 2 ? time[0] : null;
    if (month) month = monthNames[Number(month) - 1];
    if (shareFormat) return `${day || ''}-${month || ''}-${year || ''}`;
    if (appendYear) return `${day || ''} ${month || ''} ${year || ''}`;
    return `${day || ''} ${month || ''}`;
};

export const getTime = (timestamp = '') => {
    if (!timestamp) return '';
    let time = timestamp.split('T');
    time = time.length > 1 ? time[1] : null;
    if (!time) return '';
    time = time.split(':');
    const h = time[0] ? time[0] : '';
    const m = time[1] ? time[1] : '';
    devConsolelog('getTime: ', h, m);
    return `${h}:${m}`;

    // let d = new Date(timestamp);
    // // let t = d.toLocaleTimeString();
    // // return t.slice(0,-3)
    // let h = `${d.getHours() < 10 ? `0${d.getHours()}` : d.getHours()}`
    // let m = `${d.getMinutes() < 10 ? `0${d.getMinutes()}` : d.getMinutes()}`
    // devConsolelog('getTime ', d, h, m);
    // return `${h}:${m}`;
};

export const handleDateFormat = (date, monthInAlphabets = false, separatedBySpace = false, sendYear = true) => {
    if (!date) return;

    const dateArr = date.split('-');

    const year = dateArr[0];
    let month = dateArr[1];
    const day = dateArr[2];

    if (monthInAlphabets) {
        const monthNumber = Number(month);
        month = monthNames[monthNumber - 1];
    }

    if (separatedBySpace && sendYear) {
        return `${day} ${month} ${year}`;
    }
    if (separatedBySpace) {
        return `${day} ${month}`;
    }

    return [day, month, year].join('-');
};

export const rateRefundableData = (
    rate = {},
    selectedUi = false,
    onlyFreeCheck = false,
    returnOnlyText = false,
    isCustomTextStyle = false
) => {
    devConsolelog('hotel rate refund check 2', rate);
    if (isEmptyObject(rate)) return;
    let { cancellationPolicies = [] } = rate;
    const { refundable = false, refundability = '' } = rate || {};
    // if(!cancellationPolicies || cancellationPolicies.length <= 0) return null;
    if (!refundability || refundability === 'Unknown') {
        return returnOnlyText ? '' : null;
    }
    if (refundability === 'Refundable') {
        if (!cancellationPolicies || cancellationPolicies.length <= 0) {
            return returnOnlyText ? `Refundable` : <Typography variant="body1">Refundable</Typography>;
        }
        cancellationPolicies = cancellationPolicies[0];
        const { rules = [] } = cancellationPolicies;
        const isFreeCancellation = rules.find((item) => item.estimatedValue === 0);

        if (onlyFreeCheck) {
            return isFreeCancellation;
        }
        if (returnOnlyText) {
            if (isFreeCancellation) return `Free Cancellation till ${getDateAndMonth(isFreeCancellation.end)}`;
            return `Refundable`;
        }
        if (isFreeCancellation) {
            // let cancellationEndDate = new Date(item.end);
            if (selectedUi)
                return (
                    <Typography variant="body1" style={{ color: '#828282' }}>
                        <span style={{ color: '#56BE32' }}>Free Cancellation</span> till {getDateAndMonth(isFreeCancellation.end)}
                    </Typography>
                );
            if (isCustomTextStyle)
                return (
                    <Typography variant="subtitle1" style={{ fontSize: '12px' }}>
                        <span style={{ color: green, fontSize: '14px' }}>Free Cancellation</span>
                        <br /> till {`${handleDateFormat(isFreeCancellation?.end.split('T')[0])}`}
                    </Typography>
                );
            return (
                <Typography variant="body1">
                    <span style={{ color: green }}>Free Cancellation</span>
                    <br /> till {getDateAndMonth(isFreeCancellation.end)}
                </Typography>
            );
        }
        // partial cancellation
        return (
            <Typography variant="body1" style={{ fontSize: isCustomTextStyle ? '14px' : {} }}>
                Refundable
            </Typography>
        );
    }
    if (refundability === 'NonRefundable') {
        if (returnOnlyText) return 'Non Refundable';
        return (
            <Typography variant="body1" style={{ fontSize: isCustomTextStyle ? '14px' : {} }}>
                Non Refundable
            </Typography>
        );
    }
    if (returnOnlyText) return `${refundability}`;
    return (
        <Typography variant="body1" style={{ fontSize: isCustomTextStyle ? '14px' : {} }}>
            {refundability}
        </Typography>
    );
};
export const arrayCompare = (_arr1, _arr2) => {
    if (!Array.isArray(_arr1) || !Array.isArray(_arr2) || _arr1.length !== _arr2.length) {
        return false;
    }

    // .concat() to not mutate arguments
    const arr1 = _arr1.concat().sort();
    const arr2 = _arr2.concat().sort();

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
            return false;
        }
    }

    return true;
};

export const getFinalRecommendation = (selectedRooms = [], recommendations = [], rates = []) => {
    let finalSelectedRecommendation = null;

    const isFinalRecom = recommendations.find((recomItem) => {
        const { rates: recomRatesIds = [] } = recomItem;
        const finalRateIds = [];
        devConsolelog('get final recom rates', recomRatesIds, rates);
        recomRatesIds.forEach((rId) => {
            devConsolelog('get final recom rates 2', rId, rates[rId]);
            const { occupancies = [] } = rates[rId];
            occupancies.forEach((x) => {
                finalRateIds.push(rId);
            });
        });
        const selectedRateIds = selectedRooms.map((selectedItem) => selectedItem.rateId);
        // devConsolelog('hotel detailView render finalSelectedRecommendationId initial ', recomItem, r, recommendations[r])

        // devConsolelog('hotel detailView render finalSelectedRecommendationId testtt ', recomRatesIds, selectedRooms);
        return arrayCompare(finalRateIds, selectedRateIds);
        // selectedRooms.every(rr => recomRatesIds.includes(rr.rateId))
    });
    devConsolelog('hotel detailView render finalSelectedRecommendationId final ', isFinalRecom);
    if (isFinalRecom) finalSelectedRecommendation = isFinalRecom; // ['id']  //['recommendationId'];  //recommendations[r].id;
    return finalSelectedRecommendation;
};

export const isRateFreeCancellation = (rate = {}) => {
    if (isEmptyObject(rate)) return true;
    const { cancellationPolicies = [], refundable = false, refundability = '' } = rate;
    devConsolelog(
        'hotel rate refund check 1',
        rate,
        rate.id,
        rate.refundability,
        rate.boardBasis,
        refundability.toLowerCase() === 'refundable'
    );
    // if(!cancellationPolicies || cancellationPolicies.length <= 0) return null;
    // if(refundable) {
    //   cancellationPolicies = cancellationPolicies[0];
    //   let {rules = []} = cancellationPolicies;
    //   let isFreeCancellation = rules.find(item => item.estimatedValue == 0);
    //   return Boolean(isFreeCancellation);
    // } else return false;
    return refundability.toLowerCase() === 'refundable';
};

export const getRoomOccupancySummary = (occupancyData = {}) => {
    let totalAdult = 0;
    let totalChild = 0;
    const { numOfAdults = 0, childAges = [], numOfChildren = null } = occupancyData;
    totalAdult += Number(numOfAdults);
    if (childAges) totalChild += childAges.length;
    else totalChild += Number(numOfChildren);

    return `${totalAdult} Adult${totalAdult > 1 ? 's' : ''} ${totalChild > 0 ? `, ${totalChild} Child${totalChild > 1 ? 'ren' : ''}` : ''}`;
};

export const isRoomSelectionComplete = (selectedRooms = []) => selectedRooms.every((item) => !isEmptyObject(item));

export const amountINSFormat = (x = null) => {
    devConsolelog('amountINSFormat initial ', x);
    if (x == null || x === undefined) return null;
    let res = x;
    try {
        if (x < 0) {
            x = Math.abs(x);
        }
        x = x.toString();
        let afterPoint = '';
        if (x.indexOf('.') > 0) afterPoint = x.substring(x.indexOf('.'), x.length);
        x = Math.floor(x);
        x = x.toString();
        let lastThree = x.substring(x.length - 3);
        const otherNumbers = x.substring(0, x.length - 3);
        if (otherNumbers !== '') lastThree = `,${lastThree}`;
        res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree + afterPoint;
        devConsolelog('amountINSFormat success final ', res);
        return res;
    } catch (e) {
        devConsolelog('amountINSFormat error final ', e, res);
        return res;
    }
};

export const handleOccupanciesForHHi = (roomData = []) => {
    devConsolelog({
        roomData
    });
    if (!roomData || roomData.length <= 0) return;
    const newArr = [];
    roomData.forEach((item) => {
        const newObj = {};
        const { adult_count: adultCount = 0, child_ages: childAges = [], infant_count: infantCount = 0 } = item || {};
        newObj.numOfAdults = adultCount;
        const newChildAges = [...childAges];
        if (infantCount > 0) {
            Array(infantCount)
                .fill(1)
                .forEach((item) => {
                    newChildAges.push(1);
                });
        }
        newObj.childAges = newChildAges;
        newArr.push(newObj);
        devConsolelog({
            newObj
        });
    });
    return newArr;
};
export const getOccupancyHash = (data = null) => {
    if (!data) return null;
    const { childAges = [], numOfAdults = null } = data;
    return `${numOfAdults}-${childAges.join('_')}`;
};
export const handleRecommendation = ({
    hotelRoomsData,
    minimumRatePrice,
    currentRoomSelectIndex,
    recommendations,
    rates,
    occupancies,
    standardizedRooms,
    finalMasterRoomList,
    roomWiseFilter,
    filterCurrentRoomData,
    setFinalMasterRoomList,
    setMinimumRatePrice,
    setFilteredRoomList,
    setRecommRatesAvailableCounter,
    setOriginalRecommRatesCounter
}) => {
    if (isEmptyObject(hotelRoomsData)) {
        return;
    }
    const stdRooms = {};
    const newMinimumRatePriceData = minimumRatePrice?.[currentRoomSelectIndex] || {};
    const newMinimumRatePrice = { ...newMinimumRatePriceData };
    const recommRatesAvailableCounterData = {};
    recommendations.forEach((rItem, index) => {
        const {
            rates: recommendationRates = [],
            isHoldAllowedForRecommendation = false,
            travclanHoldTimeLimitForRecommendation = ''
        } = rItem || {};
        let totalRecommendationRate = 0;
        let totalRecommendationMarkedupRate = 0;
        devConsolelog('hotel detail room 1 select recommendation ', rItem.id, recommendationRates, rates);
        recommRatesAvailableCounterData[rItem.id] = {};
        recommendationRates.forEach((rateId, rateIndex) => {
            const rate = rates[rateId];
            const { occupancies: rateOccupancies = [], finalRateInRoe = 0, finalRateWithDefaultAgentMarkup = 0 } = rate;
            devConsolelog(
                '****hotel detail room 1 select rate blahhh 1',
                rItem.id,
                rateId,
                rates,
                rate,
                rateOccupancies,
                recommRatesAvailableCounterData[rItem.id][rateId]
            );
            recommRatesAvailableCounterData[rItem.id][rateId] = recommRatesAvailableCounterData?.[rItem.id]?.[rateId]
                ? recommRatesAvailableCounterData[rItem.id][rateId] + 1
                : 1;

            devConsolelog(
                ' ---- hotel detail room 1 select rate blahhh 2',
                rItem.id,
                rateId,
                recommRatesAvailableCounterData?.[rItem.id]?.[rateId]
            );
            totalRecommendationRate += finalRateInRoe;
            totalRecommendationMarkedupRate += finalRateWithDefaultAgentMarkup;

            rateOccupancies.forEach((x, xIndex) => {
                devConsolelog(
                    ' ---- ---- hotel detail room 1 select roomOption ',
                    rateOccupancies,
                    occupancies,
                    currentRoomSelectIndex
                    // getOccupancyHash(occupancies[currentRoomSelectIndex])
                );

                const newRoomOption = { ...x };
                newRoomOption.recommendationId = rItem.id;
                newRoomOption.recommendationIndex = index;
                newRoomOption.rateId = rateId;
                newRoomOption.stdRoom = standardizedRooms[newRoomOption.stdRoomId];
                newRoomOption.rateData = rates[rateId];
                newRoomOption.roomData = hotelRoomsData.rooms[newRoomOption.roomId];
                newRoomOption.isHoldAllowedForRate = isHoldAllowedForRecommendation;
                newRoomOption.holdTimeLimitForRate = travclanHoldTimeLimitForRecommendation;
                if (rateOccupancies.length > 1) {
                    newRoomOption.isRateCombo = true;
                    newRoomOption.rateComboRoomIndex = xIndex;
                }

                if (!stdRooms[newRoomOption.stdRoomId])
                    stdRooms[newRoomOption.stdRoomId] = { ...standardizedRooms[newRoomOption.stdRoomId], allRecommendedRooms: {} };

                devConsolelog('inside occupnacy hash232!!!', occupancies?.[currentRoomSelectIndex], x);
                if (getOccupancyHash(x) === getOccupancyHash(occupancies?.[currentRoomSelectIndex])) {
                    devConsolelog('hotel detail room 1 select SUCCESS ', x.roomId, rateId, rItem.id, index);
                    stdRooms[newRoomOption.stdRoomId].allRecommendedRooms[rateId] = newRoomOption;
                } else {
                    devConsolelog('hotel detail room 1 select Failed ');
                }

                return newRoomOption;
            });
        });

        recommendationRates.forEach((priceRateId) => {
            newMinimumRatePrice[priceRateId] = {
                netPrice: Math.min((newMinimumRatePrice[priceRateId] || {}).netPrice || Number.MAX_SAFE_INTEGER, totalRecommendationRate),
                markedupPrice: Math.min(
                    (newMinimumRatePrice[priceRateId] || {}).markedupPrice || Number.MAX_SAFE_INTEGER,
                    totalRecommendationMarkedupRate
                )
            };
        });
    });

    devConsolelog('hotel detail room 1 select final data ', newMinimumRatePrice, stdRooms, finalMasterRoomList, minimumRatePrice); // finalRecommendations
    const newFilteredRoomList = finalMasterRoomList ? [...finalMasterRoomList] : [];
    newFilteredRoomList[currentRoomSelectIndex] = stdRooms;
    devConsolelog('hotel setFinalMasterRoomList 2 rooms final master list update 2 ', newFilteredRoomList, roomWiseFilter);
    setFinalMasterRoomList(newFilteredRoomList);
    setFilteredRoomList([...newFilteredRoomList]); // JSON.parse(JSON.stringify(newFilteredRoomList))
    const finalMinimumRatePrice = minimumRatePrice ? [...minimumRatePrice] : [];
    finalMinimumRatePrice[currentRoomSelectIndex] = newMinimumRatePrice;
    setMinimumRatePrice(finalMinimumRatePrice);
    filterCurrentRoomData(
        cloneDeep(newFilteredRoomList),
        currentRoomSelectIndex,
        roomWiseFilter?.[currentRoomSelectIndex],
        finalMinimumRatePrice
    );
    // setResultsLoading(false);
    setRecommRatesAvailableCounter(recommRatesAvailableCounterData);
    setOriginalRecommRatesCounter(cloneDeep(recommRatesAvailableCounterData));
};

export const getRouteInfo = (formFieldGroups = [], dateOfTravel = '') => {
    if (!dateOfTravel) return [];
    const hotelForms = formFieldGroups && formFieldGroups.filter((field) => field?.key === HOTELS_AND_SIGHTSEEING || field?.key === RESORT);
    const finaRouteInfo = hotelForms?.reduce((prev, curr, idx) => {
        const areaFields = curr?.fields?.find((item) => item?.field?.key === 'area' || item?.field?.key === 'type_of_stay');
        const hotelField = curr?.fields?.find((item) => item?.field?.key === 'hotel_code');
        const nightFields = curr?.fields?.find((item) => item?.field?.key === 'number_of_nights_1');

        let travelDate;
        const routeName = areaFields?.field?.input_value?.label;
        const routeCode = areaFields?.field?.input_value?.value;
        const name = hotelField?.field?.input_value?.label;
        const code =
            hotelField?.field?.input_value?.hotelId || hotelField?.field?.input_value?.value || hotelField?.field?.input_value?.key;
        if (idx === 0) {
            const toAddNights = Number(nightFields?.field?.input_value?.value || 0);
            if (toAddNights) {
                travelDate = format(addDays(new Date(dateOfTravel), toAddNights), 'yyyy-MM-dd');
            }
        } else {
            const prevTravelDate = new Date(prev[idx - 1]?.travelDate || '');
            const toAddNights = Number(nightFields?.field?.input_value?.value || 0);
            if (toAddNights) {
                travelDate = format(addDays(new Date(prevTravelDate), toAddNights), 'yyyy-MM-dd');
            }
        }
        prev.push({
            routeName,
            routeCode,
            name,
            code,
            travelDate
        });
        return prev;
    }, []);
    return finaRouteInfo;
};

export const checkIsKeyPresentInObject = (obj, key, expectedTypeofValue = 'object') => {
    try {
        if (obj && typeof obj === 'object' && key && expectedTypeofValue) {
            const expectedType = String(expectedTypeofValue).toLowerCase();
            if (expectedType === 'array') {
                // eslint-disable-next-line no-prototype-builtins
                return obj?.hasOwnProperty(key) && Array.isArray(obj[key]);
            }
            // eslint-disable-next-line no-prototype-builtins, valid-typeof
            return obj?.hasOwnProperty(key) && typeof obj[key] === expectedType;
        }
    } catch {
        return false;
    }
    return false;
};

export const getTransfersDataFromApi = (transfersData = {}) => {
    const transfersTotalPrice = transfersData?.transferTotalPrice || 0;
    const transferTotalPriceWithRoe = transfersData?.transferTotalPriceWithRoe;
    const finalTransferType = transfersData?.finalTransferType;
    const transferMode = transfersData?.transferMode;
    const numberOfCabs = transfersData?.numberOfCabs;
    const finalTransferDetails = transfersData?.transferDetails;
    const transfersTotalCostPrice = transfersData?.transfersTotalCostPrice;
    const transfersTotalCostPriceWithRoe = transfersData?.transfersTotalCostPriceWithRoe;
    return {
        transfersTotalPrice,
        transferTotalPriceWithRoe,
        finalTransferType,
        transferMode,
        numberOfCabs,
        finalTransferDetails,
        transfersTotalCostPrice,
        transfersTotalCostPriceWithRoe
    };
};

export const extractErrorMessage = (err) => {
    if (err && typeof err === 'object' && err?.data) {
        const { errors = [] } = err?.data || {};
        return errors?.[0] || '';
    }
    return '';
};

export const getHotelsDataFromFilledFormStructure = (prefilledFormStructure, dateOfTravel, isLandOnlyQuoteAtCurrentTab = false) => {
    const { form_field_groups: formFieldGroups = [] } = prefilledFormStructure || {};
    const hotelsAndSightSeeingForm = formFieldGroups && formFieldGroups.filter((field) => field?.key === HOTELS_AND_SIGHTSEEING);
    let prevDate = new Date(dateOfTravel);
    const dayWiseItineraryHotelsPayloadInformation = hotelsAndSightSeeingForm.reduce(
        (prev, curr) => {
            const hotelFormItem = curr.fields.find((i) => i?.field?.key === HOTEL_FIELD_KEY)?.field;
            const nightFormItem = curr.fields.find((i) => i?.field?.key === NUMBER_OF_NIGHTS_FIELD_KEY)?.field;
            const areaFormItem = curr.fields.find((i) => i?.field?.key === AREA_FIELD_KEY)?.field;
            const checkIn = format(prevDate, 'yyyy-MM-dd');
            const checkOut = format(addDays(prevDate, nightFormItem.input_value.value), 'yyyy-MM-dd');
            prevDate = parse(checkOut, 'yyyy-MM-dd', new Date());
            const sightSeeingsFormItem = curr.fields.find((i) => i?.field?.key === SIGHTSEEING_FIELD)?.field?.input_value || [];
            const sightseeingData = sightSeeingsFormItem.map((item) => ({
                code: item.value,
                type: item.sightseeing_type,
                transferType: item.transfer_type
            }));
            if (isLandOnlyQuoteAtCurrentTab) {
                prev.areas.push({
                    areaCode: areaFormItem.input_value.value,
                    checkIn,
                    checkOut,
                    numberOfNights: nightFormItem.input_value.value
                });
            } else {
                prev.hotels.push({
                    areaCode: areaFormItem.input_value.value,
                    code: hotelFormItem.input_value.value,
                    numberOfNights: nightFormItem.input_value.value,
                    checkIn,
                    checkOut
                });
            }

            prev.sightseeings.push({
                areaCode: areaFormItem.input_value.value,
                checkIn,
                checkOut,
                sightseeingData
            });

            return prev;
        },
        { hotels: [], sightseeings: [], areas: [] }
    );

    return dayWiseItineraryHotelsPayloadInformation;
};

export const checkAllProvidersAndMealPlanAreSame = (providersArr = []) => {
    const defaultProvider = providersArr[0]?.rate_info?.providerName;
    const defaultMealPlan = providersArr[0]?.board_basis?.description;
    return providersArr.every(
        (item) => item?.rate_info?.providerName === defaultProvider && item?.board_basis?.description === defaultMealPlan
    );
};

export const makeRoomName = (roomsArr = []) =>
    roomsArr.reduce((prev, curr, idx) => `${prev}${curr.count} ${curr.name}${idx === roomsArr.length - 1 ? '' : ', '}`, '');

export const getTableRowColValues = (columValues = {}) => {
    const {
        numberOfChild,
        isHhiForm,
        areaName,
        newHotelName,
        roomName,
        mealPlan,
        childWithBedText,
        checkIn,
        checkOut,
        newMargin,
        totalPriceInUSD,
        totalPriceInINR,
        isOfflineComponent
    } = columValues;

    const areChildPresentInForm = numberOfChild > 0;
    const HHIFlow = isHhiForm;
    const rowArr = [];

    // Common Fields

    rowArr.push(areaName);
    rowArr.push(newHotelName);
    rowArr.push(roomName);
    rowArr.push(mealPlan);

    if (areChildPresentInForm) {
        rowArr.push(childWithBedText);
    }
    rowArr.push(checkIn);
    rowArr.push(checkOut);

    if (!HHIFlow) {
        rowArr.push(newMargin);
    }

    rowArr.push(totalPriceInUSD);
    rowArr.push(totalPriceInINR);
    rowArr.push(isOfflineComponent);

    return rowArr;
};
